<template>
  <div class="flex flex-col px-5">
    <div class="grow flex flex-col items-center justify-center">
      <h1 class="welcome__title mb-2">Hi there!</h1>
      <h3 class="welcome__subtitle mb-[64px]">
        Let's find the best time for our technician to install your new smart meter
      </h3>
      <div class="welcome__logo mb-4">
        <img :src="companyLogo" width="164" height="164" class="object-contain" alt="">
      </div>
      <div class="welcome__description" v-html="companyDescription">
      </div>
    </div>
    <Buttons>
      <Button class="btn btn__primary" :loading="isLoading" @click="startHandler">
        Start
      </Button>
    </Buttons>
  </div>

</template>

<script setup>
import Buttons from "~/components/ui/Buttons.vue";
import Button from "~/components/ui/Button.vue";
import {defineEmits, defineProps, ref} from "vue";

const config = useRuntimeConfig()
const emit = defineEmits(['start']);

const companyLogo = config.public.companyLogo || '';
const companyDescription = config.public.companyDescription || '';

defineProps({
  isLoading: {type: Boolean, default: false},
})
const startHandler = () => {
  console.log('startHandler')
  emit('start');

}
</script>

<style lang="scss" scoped>
.welcome__title {
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--dark-grey);
}

.welcome__subtitle {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: var(--grey-700);
}

.welcome__description {

  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: var(--grey-700);


}
</style>
